export const eq2 = {
  name: `eq2`,
  sql: `
    SELECT * FROM solano_eq2
    WHERE haz_eq2 IN ('Violent','Severe', 'Very Strong', 'Strong', 'Moderate')
    `,
  cartoCSS: `
    #layer {
      polygon-fill: ramp([haz_eq2], (#7efbdf, #95f879,  #f7f835, #fdca2c, #ff701f, #ec2516), ("Light", "Moderate", "Strong", "Very Strong", "Severe", "Violent"), =);
      polygon-opacity: 0.5;
      polygon-comp-op: screen;
    }
    #layer::outline {
      line-width: 0;
      line-color: #FFFFFF;
      line-opacity: 0.5;
    }
  `
}